export var SEARCH_PRODUCT_TRACK_CLICK_CONTAINER_NAME = "product_search_product_grid";
export var CATEGORY_PRODUCT_TRACK_CLICK_CONTAINER_NAME = "marketplace_product_first_grid";
